import { render, staticRenderFns } from "./PlaylistGroupedView.vue?vue&type=template&id=36059864&scoped=true"
import script from "./PlaylistGroupedView.vue?vue&type=script&lang=js"
export * from "./PlaylistGroupedView.vue?vue&type=script&lang=js"
import style0 from "./PlaylistGroupedView.vue?vue&type=style&index=0&id=36059864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36059864",
  null
  
)

export default component.exports